import { Grid } from '@material-ui/core';
import {
  EntityApiDefinitionCard,
  EntityConsumingComponentsCard,
  EntityHasApisCard,
  EntityProvidingComponentsCard,
} from '@backstage/plugin-api-docs';
import {
  EntityAboutCard,
  EntityHasComponentsCard,
  EntityHasResourcesCard,
  EntityHasSubcomponentsCard,
  EntityHasSystemsCard,
  EntityLayout,
  EntityLinksCard,
  EntitySwitch,
  EntityOrphanWarning,
  EntityProcessingErrorsPanel,
  isComponentType,
  isKind,
  hasCatalogProcessingErrors,
  isOrphan,
  hasRelationWarnings,
  EntityRelationWarning,
} from '@backstage/plugin-catalog';
import {
  EntityUserProfileCard,
  EntityGroupProfileCard,
  EntityMembersListCard,
  EntityOwnershipCard,
} from '@backstage/plugin-org';
import { EntityTechdocsContent } from '@backstage/plugin-techdocs';
import {
  Direction,
  EntityCatalogGraphCard,
} from '@backstage/plugin-catalog-graph';
import {
  Entity,
  RELATION_API_CONSUMED_BY,
  RELATION_API_PROVIDED_BY,
  RELATION_CONSUMES_API,
  RELATION_DEPENDENCY_OF,
  RELATION_DEPENDS_ON,
  RELATION_HAS_PART,
  RELATION_PART_OF,
  RELATION_PROVIDES_API,
} from '@backstage/catalog-model';

import { TechDocsAddons } from '@backstage/plugin-techdocs-react';
import { ReportIssue } from '@backstage/plugin-techdocs-module-addons-contrib';

import { EntityJenkinsContent, isJenkinsAvailable } from '@backstage-community/plugin-jenkins';
import { ProtectedRepoConfigEditor } from './EntityTabs/CICDContent/ProtectedRepoConfigEditor';
import { ProtectedDocsContent } from './EntityTabs/DocsContent/ProtectedDocsContent';
import { TabPermissionGuard } from './EntityTabs/TabPermissionGuard';

import { EntitySonarQubeCard, SonarQubeRelatedEntitiesOverview } from '@backstage-community/plugin-sonarqube';
import { isSonarQubeAvailable } from '@backstage-community/plugin-sonarqube-react';
import { ProjectForm } from './ProjectPage';
import { RequestForm } from './RequestPage/RequestForm';
import { ApplicationForm } from './AplicationPage';
import { ProjectApplications } from './ProjectPage/ProjectApplications';
import { ApplicationProjects } from './AplicationPage/ApplicationProjects';
import { ApplicationRepositories } from './AplicationPage/ApplicationRepositories';
import { EntityProjectTeamManagementContent } from '@internal/plugin-project-team-management';
import { EntityIacContent } from '@internal/plugin-autom2plataforma';
import { ComponentForm } from './Component/ComponentForm';
import { ProjectFormPage } from './ProjectPage/ProjectFormPage';
import { EntityJiraDashboardContent, isJiraDashboardAvailable } from '@axis-backstage/plugin-jira-dashboard';
import {
  EntityJiraOverviewCard,
} from '@roadiehq/backstage-plugin-jira';
import { EntityOverviewDashboardViewer } from '@backstage-community/plugin-grafana';

const techdocsContent = (
  <EntityTechdocsContent>
    <TechDocsAddons>
      <ReportIssue />
    </TechDocsAddons>
  </EntityTechdocsContent>
);

// const cicdContent = (
//   // This is an example of how you can implement your company's logic in entity page.
//   // You can for example enforce that all components of type 'service' should use GitHubActions
//   <EntitySwitch>
//     {/*
//       Here you can add support for different CI/CD services, for example
//       using @backstage-community/plugin-github-actions as follows:
//       <EntitySwitch.Case if={isGithubActionsAvailable}>
//         <EntityGithubActionsContent />
//       </EntitySwitch.Case>
//      */}
//     <EntitySwitch.Case>
//       <EmptyState
//         title="No CI/CD available for this entity"
//         missing="info"
//         description="You need to add an annotation to your component if you want to enable CI/CD for it. You can read more about annotations in Backstage by clicking the button below."
//         action={
//           <Button
//             variant="contained"
//             color="primary"
//             href="https://backstage.io/docs/features/software-catalog/well-known-annotations"
//           >
//             Read more
//           </Button>
//         }
//       />
//     </EntitySwitch.Case>
//   </EntitySwitch>
// );

const entityWarningContent = (
  <>
    <EntitySwitch>
      <EntitySwitch.Case if={isOrphan}>
        <Grid item xs={12}>
          <EntityOrphanWarning />
        </Grid>
      </EntitySwitch.Case>
    </EntitySwitch>

    <EntitySwitch>
      <EntitySwitch.Case if={hasRelationWarnings}>
        <Grid item xs={12}>
          <EntityRelationWarning />
        </Grid>
      </EntitySwitch.Case>
    </EntitySwitch>

    <EntitySwitch>
      <EntitySwitch.Case if={hasCatalogProcessingErrors}>
        <Grid item xs={12}>
          <EntityProcessingErrorsPanel />
        </Grid>
      </EntitySwitch.Case>
    </EntitySwitch>
  </>
);

const overviewComponentContent = (
  <Grid container spacing={3} alignItems="stretch">
    <TabPermissionGuard />
    {/* {entityWarningContent} */}
    <Grid item md={6}>
      <ComponentForm />
    </Grid>
    <EntitySwitch>
      <EntitySwitch.Case if={isSonarQubeAvailable}>
        <Grid item md={6}>
          <EntitySonarQubeCard variant="gridItem" />
        </Grid>
      </EntitySwitch.Case>
    </EntitySwitch>
    <Grid item xs={12}>
      <EntityLinksCard />
    </Grid>
    {/* <Grid item md={12} xs={12}>
      <EntityCatalogGraphCard variant="gridItem" height={400} />
    </Grid> */}
    {/* <Grid item xs={12}>
      <EntityHasSubcomponentsCard variant="gridItem" />
    </Grid> */}
  </Grid>
);

const overviewIaCComponentContent = (
  <Grid container spacing={3} alignItems="stretch">
    {/* {entityWarningContent} */}
    <Grid item md={12}>
      <ComponentForm />
    </Grid>
    <Grid item xs={12}>
      <EntityLinksCard />
    </Grid>
    {/* <Grid item md={12} xs={12}>
      <EntityCatalogGraphCard variant="gridItem" height={400} />
    </Grid> */}
    {/* <Grid item xs={12}>
      <EntityHasSubcomponentsCard variant="gridItem" />
    </Grid> */}
  </Grid>
);

const overviewContent = (
  <Grid container spacing={3} alignItems="stretch">
    {entityWarningContent}
    <Grid item md={6}>
      <EntityAboutCard variant="gridItem" />
    </Grid>
    <Grid item md={6} xs={12}>
      <EntityCatalogGraphCard variant="gridItem" height={400} />
    </Grid>

    <Grid item md={4} xs={12}>
      <EntityLinksCard />
    </Grid>
    <Grid item md={8} xs={12}>
      <EntityHasSubcomponentsCard variant="gridItem" />
    </Grid>
  </Grid>
);

// const overviewRequestContent = (
//   <Grid container spacing={3} alignItems="stretch">
//     {entityWarningContent}
//     <Grid item md={12}>
//       <EntityApprovalButton />
//     </Grid>
//     <Grid item md={6}>
//       <EntityAboutCard variant="gridItem" />
//     </Grid>
//     <Grid item md={6} xs={12}>
//       <EntityCatalogGraphCard variant="gridItem" height={400} />
//     </Grid>
//   </Grid>
// );

// const serviceEntityPage = (
//   <EntityLayout>
//     <EntityLayout.Route path="/" title="Overview">
//       {overviewContent}
//     </EntityLayout.Route>

//     <EntityLayout.Route path="/ci-cd" title="CI/CD">
//       {cicdContent}
//     </EntityLayout.Route>

//     <EntityLayout.Route
//       path="/kubernetes"
//       title="Kubernetes"
//       if={isKubernetesAvailable}
//     >
//       <EntityKubernetesContent />
//     </EntityLayout.Route>

//     <EntityLayout.Route path="/api" title="API">
//       <Grid container spacing={3} alignItems="stretch">
//         <Grid item md={6}>
//           <EntityProvidedApisCard />
//         </Grid>
//         <Grid item md={6}>
//           <EntityConsumedApisCard />
//         </Grid>
//       </Grid>
//     </EntityLayout.Route>

//     <EntityLayout.Route path="/dependencies" title="Dependencies">
//       <Grid container spacing={3} alignItems="stretch">
//         <Grid item md={6}>
//           <EntityDependsOnComponentsCard variant="gridItem" />
//         </Grid>
//         <Grid item md={6}>
//           <EntityDependsOnResourcesCard variant="gridItem" />
//         </Grid>
//       </Grid>
//     </EntityLayout.Route>

//     <EntityLayout.Route path="/docs" title="Docs">
//       {techdocsContent}
//     </EntityLayout.Route>
//   </EntityLayout>
// );

// const websiteEntityPage = (
//   <EntityLayout>
//     <EntityLayout.Route path="/" title="Overview">
//       {overviewContent}
//     </EntityLayout.Route>

//     <EntityLayout.Route path="/ci-cd" title="CI/CD">
//       {cicdContent}
//     </EntityLayout.Route>

//     <EntityLayout.Route
//       path="/kubernetes"
//       title="Kubernetes"
//       if={isKubernetesAvailable}
//     >
//       <EntityKubernetesContent />
//     </EntityLayout.Route>

//     <EntityLayout.Route path="/dependencies" title="Dependencies">
//       <Grid container spacing={3} alignItems="stretch">
//         <Grid item md={6}>
//           <EntityDependsOnComponentsCard variant="gridItem" />
//         </Grid>
//         <Grid item md={6}>
//           <EntityDependsOnResourcesCard variant="gridItem" />
//         </Grid>
//       </Grid>
//     </EntityLayout.Route>

//     <EntityLayout.Route path="/docs" title="Docs">
//       {techdocsContent}
//     </EntityLayout.Route>
//   </EntityLayout>
// );

/**
 * NOTE: This page is designed to work on small screens such as mobile devices.
 * This is based on Material UI Grid. If breakpoints are used, each grid item must set the `xs` prop to a column size or to `true`,
 * since this does not default. If no breakpoints are used, the items will equitably share the available space.
 * https://material-ui.com/components/grid/#basic-grid.
 */

const defaultEntityPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      {overviewContent}
    </EntityLayout.Route>

    <EntityLayout.Route path="/docs" title="Docs">
      {techdocsContent}
    </EntityLayout.Route>
  </EntityLayout>
);

const defaultComponentPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      {overviewComponentContent}
    </EntityLayout.Route>

    <EntityLayout.Route path="/ci-cd" title="Jenkins" if={isJenkinsAvailable}>
      <EntityJenkinsContent title="Pipelines" />
    </EntityLayout.Route>

    <EntityLayout.Route path="/config" title="Build & Deploy">
      <ProtectedRepoConfigEditor />
    </EntityLayout.Route>

    <EntityLayout.Route path="/docs" title="Docs">
      <ProtectedDocsContent />
    </EntityLayout.Route>
  </EntityLayout>
);

const iacEntityPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      {overviewIaCComponentContent}
    </EntityLayout.Route>
    <EntityLayout.Route path="/docs" title="Docs">
      {techdocsContent}
    </EntityLayout.Route>
  </EntityLayout>
);

const requestEntityPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Request">
      <RequestForm />
    </EntityLayout.Route>
  </EntityLayout>
);

const dashboardEntityPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Dashboard">
      <EntityOverviewDashboardViewer />
    </EntityLayout.Route>
    <EntityLayout.Route path="/overwiew" title="Overview">
      <EntityAboutCard variant="gridItem" />
    </EntityLayout.Route>
  </EntityLayout>
);

const showIfParent = (entity: Entity) => !entity?.spec?.parent;

const projectPage = (
  <EntityLayout>

    <EntityLayout.Route path="/" title="Overview">
      <>
        <TabPermissionGuard />
        <ProjectFormPage />
      </>
    </EntityLayout.Route>

    <EntityLayout.Route path="/applications" title="Applications">
      <>
        <Grid item xs={12} style={{ marginBottom: 30 }}>
          <ProjectForm />
        </Grid>
        <ProjectApplications />
      </>
    </EntityLayout.Route>

    <EntityLayout.Route path="/team" title="Team" if={showIfParent}>
      <>
        <Grid item xs={12} style={{ marginBottom: 30 }}>
          <ProjectForm />
        </Grid>
        <EntityProjectTeamManagementContent />
      </>
    </EntityLayout.Route>

    <EntityLayout.Route path="/jira" title="Jira" if={isJiraDashboardAvailable}>
      <>
        <EntityJiraDashboardContent />
        <EntityJiraOverviewCard />
      </>
    </EntityLayout.Route>

    {/* <EntityLayout.Route path="/jira2" title="Jira 2" if={isJiraAvailable}>
      <EntitySwitch>
        <EntitySwitch.Case if={isJiraAvailable}>
          <Grid item md={12}>
            <EntityJiraOverviewCard />
          </Grid>
        </EntitySwitch.Case>
      </EntitySwitch>
    </EntityLayout.Route> */}

    {/* <EntityLayout.Route path="/docs" title="Docs">
      {techdocsContent}
    </EntityLayout.Route> */}
  </EntityLayout>
);

const requestPage = (
  <EntitySwitch>
    {/* <EntitySwitch.Case if={isComponentType('repository')}>
      {serviceEntityPage}
    </EntitySwitch.Case>

    <EntitySwitch.Case if={isComponentType('permission')}>
      {websiteEntityPage}
    </EntitySwitch.Case> */}

    <EntitySwitch.Case>{requestEntityPage}</EntitySwitch.Case>
  </EntitySwitch>
);

const componentPage = (
  <EntitySwitch>
    {/* <EntitySwitch.Case if={isComponentType('service')}>
      {serviceEntityPage}
    </EntitySwitch.Case>

    <EntitySwitch.Case if={isComponentType('website')}>
      {websiteEntityPage}
    </EntitySwitch.Case> */}

    <EntitySwitch.Case if={isComponentType('IAC - Código de Infraestuctura')}>
      {iacEntityPage}
    </EntitySwitch.Case>

    <EntitySwitch.Case if={isComponentType('request')}>
      {requestEntityPage}
    </EntitySwitch.Case>

    <EntitySwitch.Case if={isComponentType('dashboard')}>
      {dashboardEntityPage}
    </EntitySwitch.Case>

    <EntitySwitch.Case if={isComponentType('documentation')}>
      <EntityLayout>
        <EntityLayout.Route path="/" title="Overview">
          {overviewContent}
        </EntityLayout.Route>
        <EntityLayout.Route path="/docs" title="Docs">
          {techdocsContent}
        </EntityLayout.Route>
      </EntityLayout>
    </EntitySwitch.Case>

    <EntitySwitch.Case>{defaultComponentPage}</EntitySwitch.Case>
  </EntitySwitch>
);

const apiPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      <Grid container spacing={3}>
        {entityWarningContent}
        <Grid item md={12}>
          <EntityAboutCard />
        </Grid>
        {/* <Grid item md={6} xs={12}>
          <EntityCatalogGraphCard variant="gridItem" height={400} />
        </Grid>
        <Grid item md={4} xs={12}>
          <EntityLinksCard />
        </Grid> */}
        <Grid container item md={12}>
          <Grid item md={6}>
            <EntityProvidingComponentsCard />
          </Grid>
          <Grid item md={6}>
            <EntityConsumingComponentsCard />
          </Grid>
        </Grid>
      </Grid>
    </EntityLayout.Route>

    <EntityLayout.Route path="/definition" title="Definition">
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <EntityApiDefinitionCard />
        </Grid>
      </Grid>
    </EntityLayout.Route>
  </EntityLayout>
);

const userPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      <Grid container spacing={3}>
        {entityWarningContent}
        <Grid item xs={12} md={6}>
          <EntityUserProfileCard variant="gridItem" />
        </Grid>
        <Grid item xs={12} md={6}>
          <EntityOwnershipCard variant="gridItem" />
        </Grid>
      </Grid>
    </EntityLayout.Route>
  </EntityLayout>
);

const groupPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      <Grid container spacing={3}>
        {entityWarningContent}
        <Grid item xs={12}>
          <EntityGroupProfileCard variant="gridItem" />
        </Grid>
        <Grid item xs={12}>
          <EntityMembersListCard />
        </Grid>
      </Grid>
    </EntityLayout.Route>
  </EntityLayout>
);

const systemPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      <Grid container spacing={3} alignItems="stretch">
        {entityWarningContent}
        <Grid item md={6}>
          <EntityAboutCard variant="gridItem" />
        </Grid>
        <Grid item md={6} xs={12}>
          <EntityCatalogGraphCard variant="gridItem" height={400} />
        </Grid>
        <Grid item md={4} xs={12}>
          <EntityLinksCard />
        </Grid>
        <Grid item md={8}>
          <EntityHasComponentsCard variant="gridItem" />
        </Grid>
        <Grid item md={6}>
          <EntityHasApisCard variant="gridItem" />
        </Grid>
        <Grid item md={6}>
          <EntityHasResourcesCard variant="gridItem" />
        </Grid>
      </Grid>
    </EntityLayout.Route>
    <EntityLayout.Route path="/diagram" title="Diagram">
      <EntityCatalogGraphCard
        variant="gridItem"
        direction={Direction.TOP_BOTTOM}
        title="System Diagram"
        height={700}
        relations={[
          RELATION_PART_OF,
          RELATION_HAS_PART,
          RELATION_API_CONSUMED_BY,
          RELATION_API_PROVIDED_BY,
          RELATION_CONSUMES_API,
          RELATION_PROVIDES_API,
          RELATION_DEPENDENCY_OF,
          RELATION_DEPENDS_ON,
        ]}
        unidirectional={false}
      />
    </EntityLayout.Route>
  </EntityLayout>
);

const applicationPage = (
  <EntityLayout>

    <EntityLayout.Route path="/" title="Overview">
      <>
        <TabPermissionGuard />
        <ApplicationRepositories />
      </>
    </EntityLayout.Route>

    <EntityLayout.Route path="/projects" title="Projects">
      <ApplicationProjects />
    </EntityLayout.Route>

    {/*
      "IaC": infrastructures requested for this Application through the
      "Creación de IaC MVP" golden path, plus the health of the poller that
      tracks them.

      Mounted for every Application rather than behind an `if=` guard:
      `EntityLayout.Route.if` is synchronous (`(entity) => boolean`) and the
      permission (`can_view_details` on the Application) can only be resolved
      asynchronously against OpenFGA. The listing endpoint is authorised and
      fail-closed server-side, and the tab renders an explicit "no tienes
      permiso" panel instead of an empty list — deliberately not extending the
      DOM/MutationObserver approach of TabPermissionGuard.
    */}
    <EntityLayout.Route path="/iac" title="Entornos">
      <EntityIacContent />
    </EntityLayout.Route>

    <EntityLayout.Route path="/sonarqube" title="Code Quality">
      <>
        <Grid item xs={12} style={{ marginBottom: 30 }}>
          <ApplicationForm />
        </Grid>
        <SonarQubeRelatedEntitiesOverview relationType={RELATION_HAS_PART} entityKind="component" />
      </>
    </EntityLayout.Route>

    {/* <EntityLayout.Route path="/diagram" title="Diagram">
      <EntityCatalogGraphCard
        variant="gridItem"
        direction={Direction.TOP_BOTTOM}
        title="System Diagram"
        height={700}
        relations={[
          RELATION_PART_OF,
          RELATION_HAS_PART,
          RELATION_API_CONSUMED_BY,
          RELATION_API_PROVIDED_BY,
          RELATION_CONSUMES_API,
          RELATION_PROVIDES_API,
          RELATION_DEPENDENCY_OF,
          RELATION_DEPENDS_ON,
        ]}
        unidirectional={false}
      />
    </EntityLayout.Route> */}
  </EntityLayout>
);

const domainPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      <Grid container spacing={3} alignItems="stretch">
        {entityWarningContent}
        <Grid item md={6}>
          <EntityAboutCard variant="gridItem" />
        </Grid>
        <Grid item md={6} xs={12}>
          <EntityCatalogGraphCard variant="gridItem" height={400} />
        </Grid>
        <Grid item md={6}>
          <EntityHasSystemsCard variant="gridItem" />
        </Grid>
      </Grid>
    </EntityLayout.Route>
  </EntityLayout>
);

export const entityPage = (
  <EntitySwitch>
    <EntitySwitch.Case if={isKind('component')} children={componentPage} />
    <EntitySwitch.Case if={isKind('api')} children={apiPage} />
    <EntitySwitch.Case if={isKind('group')} children={groupPage} />
    <EntitySwitch.Case if={isKind('user')} children={userPage} />
    <EntitySwitch.Case if={isKind('system')} children={systemPage} />
    <EntitySwitch.Case if={isKind('domain')} children={domainPage} />
    <EntitySwitch.Case if={isKind('application')} children={applicationPage} />
    <EntitySwitch.Case if={isKind('project')} children={projectPage} />
    <EntitySwitch.Case if={isKind('request')} children={requestPage} />

    <EntitySwitch.Case>{defaultEntityPage}</EntitySwitch.Case>
  </EntitySwitch>
);
